import { OnInit } from '@angular/core';
import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IThesisReport } from '../../models/ThesisReport';
import { AppService } from '../../services/app.service';
import { ThesisReportService } from '../../services/thesis-report.service';

@Component({
    selector: 'app-thesis-report-form',
    templateUrl: './form.component.html'
})
export class ThesisReportFormComponent implements OnInit {
    constructor(
        private app: AppService,
        private service: ThesisReportService,
        private route: ActivatedRoute
    ) { }

    isReady: boolean;
    report?: IThesisReport;

    ngOnInit() {
        const id = +this.route.snapshot.params['id'];

        if (id) {
            this.app.addLoading(this.service.getById(id)).subscribe(data => {
                this.report = data;
                this.isReady = true;
            });
        } else {
            this.isReady = true;
        }
    }
}
